/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import clsx from 'clsx'

type FormGridProps = {
    children: React.ReactNode | React.ReactNode[]
    cols?: number
    gap?: number
    responsive?: boolean
    className?: string
}

const UiFormGrid: React.FC<FormGridProps> = ({
    children,
    cols = 2,
    gap = 6,
    responsive = true,
    className,
}) => {
    const mdCols = (() => {
        switch (cols) {
            case 1:
                return 'md:grid-cols-1'
            case 2:
                return 'md:grid-cols-2'
            case 3:
                return 'md:grid-cols-3'
            case 4:
                return 'md:grid-cols-4'
            case 5:
                return 'md:grid-cols-5'
            case 6:
                return 'md:grid-cols-6'
            case 12:
                return 'md:grid-cols-12'
            default:
                return 'md:grid-cols-2'
        }
    })()

    const gapClass = (() => {
        switch (gap) {
            case 1:
                return 'gap-1'
            case 2:
                return 'gap-2'
            case 3:
                return 'gap-3'
            case 4:
                return 'gap-4'
            case 5:
                return 'gap-5'
            case 6:
                return 'gap-6'
            case 8:
                return 'gap-8'
            default:
                return 'gap-6'
        }
    })()

    const baseCols = responsive
        ? clsx('grid-cols-1', mdCols)
        : cols === 1
          ? 'grid-cols-1'
          : mdCols
    return (
        <div className={clsx('UiFormGrid grid', baseCols, gapClass, className)}>
            {children}
        </div>
    )
}

export default UiFormGrid
